import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import Button from '../../../../Button'
import {
  QA_NAME_INTEGRATIONS_CONNECT,
  QA_NAME_INTEGRATIONS_DISCONNECT,
} from '../../RentalPortalIntegrations.constants'
import { getIsIntegrationPortalEnabled } from '../../RentalPortalIntegrations.utils'
import {
  getIntegrationsPanelConnectBlockKey,
  getIntegrationsPanelPermissionBlockKey,
  getIntegrationsPanelPrimaryKey,
} from '../RentalPortalIntegrationsPanel.utils'

import * as styles from './IntegrationsPanelActions.module.css'

function IntegrationsPanelActions({
  canConfigure,
  connection,
  hasConnection,
  isConnected,
  onConnect,
  onDisconnect,
}) {
  const { t } = useTranslation()

  const connectBlockKey = getIntegrationsPanelConnectBlockKey({
    canConfigure,
    isPortalEnabled: getIsIntegrationPortalEnabled(connection),
  })

  const disconnectBlockKey =
    getIntegrationsPanelPermissionBlockKey(canConfigure)

  return (
    <div className={styles.IntegrationsPanelActions}>
      {isConnected ? null : (
        <Button.Contained
          disabled={Boolean(connectBlockKey)}
          qaName={QA_NAME_INTEGRATIONS_CONNECT}
          text={t(getIntegrationsPanelPrimaryKey(hasConnection))}
          tooltip={connectBlockKey ? t(connectBlockKey) : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onConnect}
        />
      )}
      {hasConnection ? (
        <Button.Outlined
          isDanger
          disabled={Boolean(disconnectBlockKey)}
          qaName={QA_NAME_INTEGRATIONS_DISCONNECT}
          text={t('RentalPortal.IntegrationsDisconnectBtnKey')}
          tooltip={disconnectBlockKey ? t(disconnectBlockKey) : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onDisconnect}
        />
      ) : null}
    </div>
  )
}

export default IntegrationsPanelActions
